// Agent Assignment Types

export interface AgentAssignment {
  id: string;
  agent_id: string;
  player_id: string;
  package_type_id: string;
  agent_type: string;
  commission_percentage?: number;
  share_percentage?: number;
  max_bet_limit: number;
  facilities_agreed: boolean;
  is_active: boolean;
  created_at: string;
  updated_at?: string;
  agent?: {
    id: string;
    name: string;
    [key: string]: unknown;
  };
  player?: {
    id: string;
    name: string;
    [key: string]: unknown;
  };
  package_type?: {
    id: string;
    name: string;
    [key: string]: unknown;
  };
}

export interface CreateAgentAssignmentRequest {
  agent_id: string;
  player_id: string;
  package_type_id: string;
  agent_type: string;
  commission_percentage?: number;
  share_percentage?: number;
  max_bet_limit: number;
  facilities_agreed: boolean;
}

export interface UpdateAgentAssignmentRequest {
  commission_percentage?: number;
  share_percentage?: number;
  max_bet_limit?: number;
  facilities_agreed?: boolean;
}

export interface AgentAssignmentListParams {
  agent_id?: string;
  player_id?: string;
  package_type_id?: string;
  is_active?: boolean;
  skip?: number;
  limit?: number;
}

export interface AgentAssignmentListResponse {
  items: AgentAssignment[];
  total: number;
  skip: number;
  limit: number;
}

// Player Facility Types

export interface PlayerFacility {
  id: string;
  player_id: string;
  assignment_id?: string;
  facility_category_id: string;
  facility_name: string;
  description?: string;
  estimated_cost?: number;
  actual_cost: number;
  provided_date: string;
  vendor_name?: string;
  invoice_number?: string;
  notes?: string;
  status: FacilityStatus;
  was_eligible: boolean;
  eligibility_reason?: string;
  requires_approval: boolean;
  approved_by?: string;
  approved_at?: string;
  created_at: string;
  updated_at?: string;
  player?: {
    id: string;
    name: string;
    [key: string]: unknown;
  };
  assignment?: {
    id: string;
    [key: string]: unknown;
  };
  facility_category?: {
    id: string;
    name: string;
    [key: string]: unknown;
  };
}

export enum FacilityStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  COMPLETED = "COMPLETED",
}

export interface CreatePlayerFacilityRequest {
  player_id: string;
  assignment_id?: string;
  facility_category_id: string;
  facility_name: string;
  description?: string;
  estimated_cost?: number;
  actual_cost: number;
  provided_date: string;
  vendor_name?: string;
  invoice_number?: string;
  notes?: string;
}

export interface PlayerFacilityListParams {
  player_id?: string;
  assignment_id?: string;
  status?: string;
  skip?: number;
  limit?: number;
}

export interface PlayerFacilityListResponse {
  items: PlayerFacility[];
  total: number;
  skip: number;
  limit: number;
}
